import $ from 'jquery';
import globalScope from 'core/globalScope';

const window = globalScope.window;

function shouldCache(ceVersion) {
  return typeof ceVersion === 'string' && ceVersion.indexOf('SNAPSHOT') < 0;
}

export default {
  trackerPageViewAsync: function(dataContainer, ceVersion) {
    const script =
      globalScope.domainUrlAssets + '/assets/js/external/tagCommander/tc_Cadremploi_navigation.js';

    // mise � jour de l'objet global tc_vars
    window.tc_vars = dataContainer;

    // rechargement du JS TagCommander avec le numero de version cadremploi pour eviter les pbs de cache
    if (shouldCache(ceVersion)) {
      // on active le cache de script jquery via le setup global le temps de la requete
      // car on s'occupe nous meme de la gestion du cache par version de cadremploi
      $.ajaxSetup({
        cache: true
      });
      $.getScript(script + '?v=' + ceVersion);

      // on re-desactive le cache de script global jquery apr�s la requ�te
      $.ajaxSetup({
        cache: false
      });
    } else {
      // on laisse jquery s'assurer que le fichier sera charg� en bypassant le cache navigateur
      // (via l'ajout d'un parametre '?_=timestamp' dans la requete)
      $.getScript(script);
    }
  }
};
